import { Space } from 'antd';
import React from 'react';
import PageTitle from '../../common/PageTitle';

import { useTranslation } from 'react-i18next';
import { getActions } from '../actions/courseListActions';
import { useUserProfileQuery } from '../../../features/auth/authApi';
import CourseList from '../components/courseList';
import { useGetCourseDraftsListQuery } from '../../../features/courses/coursesApi';

const CoursesDraftsPage = () => {
    const { t } = useTranslation();
    const { data: user } = useUserProfileQuery('userDetails');
    const { data: courses } = useGetCourseDraftsListQuery(
        'course-draft-catalog'
    );

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <PageTitle
                title={t('workbench.courses.header' ) as String}
                actions={getActions(user)}
            />
            <CourseList courses={courses} user={user} />
        </Space>
    );
};

export default CoursesDraftsPage;
